function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_476",
  "data-name": "Path 476",
  d: "M506.006,203.5v88.964H704.217V203.5Zm.712,88.252v-87.54H555.47v87.54Zm49.464-87.54h56.225v87.54H556.181ZM703.5,291.752H613.118v-87.54H703.5Z",
  transform: "translate(-374.692 -203.5)",
  fill: "#3f3d56"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_477",
  "data-name": "Path 477",
  d: "M544.973,296.453H531.488c1.517-6.223,2.974-12.033,0-16.181h13.485A18.146,18.146,0,0,1,544.973,296.453Z",
  transform: "translate(-391.106 -252.952)",
  fill: "#f0b543"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_478",
  "data-name": "Path 478",
  d: "M735.068,381.9H721.583c-.843-7.5,1.017-13.092,0-16.181h13.485a84.425,84.425,0,0,0,0,16.181Z",
  transform: "translate(-513.409 -307.993)",
  fill: "#e6e6e6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_479",
  "data-name": "Path 479",
  d: "M689.179,315.662H675.694c.506-6.222,2.136-12.032,0-16.181h13.485A18.141,18.141,0,0,1,689.179,315.662Z",
  transform: "translate(-483.996 -265.326)",
  fill: "#f0b543"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_480",
  "data-name": "Path 480",
  d: "M742.877,285.927h13.485c.843-6.223-1.017-12.033,0-16.181H742.877A18.141,18.141,0,0,0,742.877,285.927Z",
  transform: "translate(-526.044 -246.171)",
  fill: "#ff6584"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_481",
  "data-name": "Path 481",
  d: "M567.093,367.924h13.484c.843-6.223-1.017-12.033,0-16.181H567.093A18.141,18.141,0,0,0,567.093,367.924Z",
  transform: "translate(-412.814 -298.99)",
  fill: "#e6e6e6"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_563",
  "data-name": "Rectangle 563",
  width: 19.891,
  height: 0.712,
  transform: "translate(144.518 7.635)",
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_564",
  "data-name": "Rectangle 564",
  width: 19.891,
  height: 0.712,
  transform: "translate(199.319 7.635)",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_565",
  "data-name": "Rectangle 565",
  width: 19.891,
  height: 0.712,
  transform: "translate(273.693 7.635)",
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_482",
  "data-name": "Path 482",
  d: "M195.908,537.975v.974a6.091,6.091,0,0,0,6.086,6.086H253.6a6.088,6.088,0,0,0,6.086-6.086v-.974a6.042,6.042,0,0,0-1.412-3.9,6.26,6.26,0,0,0-1.027-.974H230.48a1.218,1.218,0,0,1-1.217-1.217h-27.27A6.094,6.094,0,0,0,195.908,537.975Z",
  transform: "translate(-174.943 -415.031)",
  fill: "#ccc"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_566",
  "data-name": "Rectangle 566",
  width: 6.329,
  height: 44.792,
  transform: "translate(55.778 174.555) rotate(180)",
  fill: "#ccc"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_483",
  "data-name": "Path 483",
  d: "M225.33,682.345c0,.684,9.591.265,21.422.265s21.422.419,21.422-.265-9.591-6.107-21.422-6.107S225.33,681.661,225.33,682.345Z",
  transform: "translate(-193.895 -508.012)",
  fill: "#ccc"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_484",
  "data-name": "Path 484",
  d: "M239.091,432.284h6.046l2.876-23.322H239.09Z",
  transform: "translate(-154.009 -263.431)",
  fill: "#a0616a"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_485",
  "data-name": "Path 485",
  d: "M371.753,672.451h11.908a7.589,7.589,0,0,1,7.588,7.588v.247h-19.5Z",
  transform: "translate(-288.213 -505.573)",
  fill: "#2f2e41"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M135.489,405.491l-4.9,3.544-16-17.208,7.23-5.231Z",
  transform: "translate(-73.811 -249.025)",
  fill: "#a0616a"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_487",
  "data-name": "Path 487",
  d: "M292.021,642.506l-15.795,11.428-.145-.2a7.589,7.589,0,0,1,1.7-10.6h0l9.647-6.98Z",
  transform: "translate(-225.658 -482.195)",
  fill: "#2f2e41"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_488",
  "data-name": "Path 488",
  d: "M296.42,384.616a11.553,11.553,0,0,0-13.2,0l-4.747,39.6h14.255l2.112-12.671,4.752-19.006Z",
  transform: "translate(-228.125 -318.805)",
  fill: "#ccc"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M274.325,515.566l-25.583-8.354-12.2,9.678L249.5,536.7l-6.777,8.887-.194-.221c-.841-.958-20.59-23.527-20.533-29.928a48.16,48.16,0,0,1,2.181-12.792l6.415-9.106,9.105-2.678,30.145,4.231.049.007,12.179,7.413a9.568,9.568,0,0,1,4.343,7.045c.523,4.707,1.575,42.4,1.585,42.784l.007.247H274.853Z",
  transform: "translate(-191.749 -388.602)",
  fill: "#2f2e41"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_490",
  "data-name": "Path 490",
  d: "M258.132,437.452c-4.446-1.976-10.125-9.692-11.061-10.993-1.83,1-15.172,8.127-18.934,6.294-.546.3-3.016,1.775-3.461,4l-.112.558-.322-.469c-.059-.086-5.854-8.7,1.642-14.059,6.836-4.882,8.675-9.815,8.867-10.379l-3.709-19.6.1-.09c.3-.282,7.524-6.926,14.113-7.716l4.064-.716.178,15.472v19.807c3.284-.413,8.479-35.021,8.479-35.021l2.715.995c.7.135,8.584,1.709,10.676,4.847l.068.1-7.17,19.385-2.1,3.157v4.041l12.25,10.652-.174.182c-.417.437-9.451,9.833-14.713,9.831A3.411,3.411,0,0,1,258.132,437.452Z",
  transform: "translate(-191.783 -319.946)",
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_232",
  "data-name": "Ellipse 232",
  cx: 11.811,
  cy: 11.811,
  r: 11.811,
  transform: "translate(45.651 53.264) rotate(-61.337)",
  fill: "#a0616a"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_491",
  "data-name": "Path 491",
  d: "M301.892,521.959a4.624,4.624,0,0,1,5.964-3.837l6.77-8.115,5.935,2.911-9.721,11.326a4.65,4.65,0,0,1-8.947-2.285Z",
  transform: "translate(-243.186 -400.935)",
  fill: "#a0616a"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M315.412,442.646l10.62-14.337L323.4,414.1l4.268-16,.107-.046a5.507,5.507,0,0,1,3.683-.253,2.49,2.49,0,0,1,1.386,1.44c1.057,2.642,3.6,29.544,3.712,30.734-.022.217-.545,5.348-1.608,7.475s-10.713,12.8-11.124,13.253l-.17.187Z",
  transform: "translate(-251.921 -328.504)",
  fill: "#3f3d56"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Path_493",
  "data-name": "Path 493",
  d: "M290.367,307c-3.931,4.945-10.67,4.038-16.061,2.229a17.085,17.085,0,0,1-3.04,11.154c.7-2.8-2.237-3.363-3.948-4.406-.659-.834-.112-2.079-.382-3.107-3.073-3.6-5.109-6.321-1.165-10.549,2.309-3.091,5.081-6.951,9.481-6.139,3.481-4.061,9.186-3.005,13.079-.164a27.809,27.809,0,0,1,4.743,4.457,18.879,18.879,0,0,1-2.464,6.189",
  transform: "translate(-218.541 -261.473)",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "Path_494",
  "data-name": "Path 494",
  d: "M272.93,695.212H137.35a.356.356,0,1,1,0-.712H272.93a.356.356,0,1,1,0,.712Z",
  transform: "translate(-136.994 -519.776)",
  fill: "#3f3d56"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M305.6,532.587H292.116c.506-6.222,2.136-12.032,0-16.182H305.6A18.141,18.141,0,0,1,305.6,532.587Z",
  transform: "translate(-236.915 -405.057)",
  fill: "#f0b543"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  id: "Path_496",
  "data-name": "Path 496",
  d: "M279.661,531.66a4.625,4.625,0,0,0-5.964-3.837l-6.77-8.115-5.935,2.911,9.721,11.326a4.65,4.65,0,0,0,8.947-2.285Z",
  transform: "translate(-216.867 -407.184)",
  fill: "#a0616a"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "Path_497",
  "data-name": "Path 497",
  d: "M244.59,456.425c-.605-.454-14.846-11.158-16.437-14.339s-1.2-12.625-1.178-13.054c.025-.148,2.5-14.9,4.6-20.14,2.176-5.44,7.649-3.324,7.7-3.3l.165.066-2.383,27.8,13,17.244-5.3,5.853Z",
  transform: "translate(-194.918 -333.403)",
  fill: "#3f3d56"
});

function SvgSalesSlicks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_94_1",
    "data-name": "Component 94 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 329.525,
    height: 175.436,
    viewBox: "0 0 329.525 175.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesSlicks);
export default __webpack_public_path__ + "static/media/sales_slicks.d6b74cf6.svg";
export { ForwardRef as ReactComponent };